import st from './Intor.module.scss'
import {Button} from "components/Button/Button";
import introBg from 'assets/images/intro-bg.png';
import introBgM from 'assets/images/intro-bg-m.png';
import {FormModal} from '../../modal/FormModal';
import {useState} from 'react';

export const Intro =()=> {
    const [isOpen, setIsOpen] = useState(false)
    const openModal = () => setIsOpen(true)
    return (
        <div className={st.intro}>
            <div className={st.bg}>
                <picture>
                    <source media="(max-width: 768px)" srcSet={introBgM} />
                    <img src={introBg} alt="" />
                </picture>
            </div>
            <div className={st.over}>
                <div className={`wrapper ${st.over_wrap}`}>
                    <div className={st.content}>
                        <p>
                            ФЕДЕРАЛЬНЫЙ ПАРТИЙНЫЙ ПРОЕКТ «ЖЕНСКОЕ ДВИЖЕНИЕ ЕДИНОЙ РОССИИ» — ЭТО БОЛЕЕ 100 ТЫСЯЧ УЧАСТНИЦ И СВЫШЕ 80 РЕГИОНОВ.
                        </p>
                        <p>
                            «Женское движение» является единой платформой для продвижения и развития женских инициатив во всех сферах жизни российского общества, содействует реализации Национальной стратегии в интересах женщин.
                        </p>

                        <p>
                            В рамках проекта женщины всех возрастов и профессий объединяют свои силы, раскрывают свои таланты, самореализуются и достигают успеха!
                        </p>

                        <p>
                            Женщины-волонтёры и общественники, политики и предприниматели, члены семей участников специальной военной операции и многодетные матери – все вместе это «Женское Движение Единой России»!
                        </p>
                    </div>
                    <div className={st.over_btn}>
                        <Button
                            text="Вступить"
                            onClick={openModal}
                        />
                        <Button
                            type="link"
                            to="/areas-of-work"
                            text="НАПРАВЛЕНИЯ РАБОТЫ"
                            variant="button_blue"
                        />
                    </div>
                </div>
            </div>

            <FormModal isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
    )
}
